import React from "react";

import {

  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,

} from "reactstrap";


export default class FamilyTreeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  open: true };
    this.close = this.close.bind(this);
  }

  close() {
    this.setState({ open: false });
    if(this.props.dialogClosed){
    this.props.dialogClosed();
    }
  }
  render() {
    return (
          <Modal isOpen={this.state.open}>
          <ModalHeader toggle={this.close}>
          </ModalHeader>
          <ModalBody>
          <iframe src={"http://www.almotanabbi.com/previewTagFamilyTree.do?tagId="+this.props.tagId} style={{width:'880px', height:'580px'}}></iframe>
          </ModalBody>

          </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/FamilyTreeDialog.js